import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "text" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<span class=\"icon-compare\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span><span class=\"path5\"></span></span>", 1)
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  class: "icon-compare",
  ref: "compareButton"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span><span class=\"path5\"></span>", 5)
const _hoisted_11 = [
  _hoisted_6
]
const _hoisted_12 = {
  key: 0,
  class: "compare-anim",
  ref: "compareAnim"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_easy_login_form = _resolveComponent("easy-login-form")!

  return (!_ctx.isEstateAgencyMode)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.isDetail)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.compare && _ctx.compare(...args))),
              class: _normalizeClass([{ 'is-active': _ctx.ad.isCompare }, "button button--compare"]),
              title: _ctx.$t('AdListItemCompare.button-compare-title')
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('AdListItemCompare.button-compare')), 1),
              _hoisted_3
            ], 10, _hoisted_1))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.compare && _ctx.compare(...args)), ["stop","prevent"])),
              class: _normalizeClass(["estate-card__compare", { 'is-active': _ctx.ad.isCompare }]),
              title: _ctx.$t('AdListItemCompare.button-compare-title')
            }, [
              _createElementVNode("span", _hoisted_5, _hoisted_11, 512)
            ], 10, _hoisted_4)),
        (_ctx.isLoginModalVisible)
          ? (_openBlock(), _createBlock(_Teleport, {
              key: 2,
              to: "#container"
            }, [
              _createVNode(_component_easy_login_form, {
                onClose: _ctx.closeLoginModal,
                showCloseButton: true,
                alertText: _ctx.$t('compare-not-logged-in')
              }, null, 8, ["onClose", "alertText"])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_Teleport, { to: "#container" }, [
          _createVNode(_Transition, {
            onBeforeEnter: _ctx.beforeEnter,
            onEnter: _ctx.enter,
            onAfterEnter: _ctx.afterEnter
          }, {
            default: _withCtx(() => [
              (_ctx.showAnimation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, null, 512))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onBeforeEnter", "onEnter", "onAfterEnter"])
        ]))
      ], 64))
    : _createCommentVNode("", true)
}